module.exports = __webpack_public_path__ + "img/detail_portrait_default_woman@2x.1d95beb9.png";